/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LibertacaoCaucaoFontesSeladasCriteriaDto } from '../models/libertacao-caucao-fontes-seladas-criteria-dto';
import { LibertacaoCaucaoFontesSeladasDto } from '../models/libertacao-caucao-fontes-seladas-dto';
import { LibertacaoCaucaoFontesSeladasFormCreateDto } from '../models/libertacao-caucao-fontes-seladas-form-create-dto';
import { LibertacaoCaucaoFontesSeladasFormUpdateDto } from '../models/libertacao-caucao-fontes-seladas-form-update-dto';
import { LibertacaoCaucaoFontesSeladasPageDto } from '../models/libertacao-caucao-fontes-seladas-page-dto';


/**
 * Libertação da Caução Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class LibertacaoCaucaoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getLibertacaoFsList
   */
  static readonly GetLibertacaoFsListPath = '/libertacao-caucao-fontes-seladas';

  /**
   * Pesquisar libertação de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLibertacaoFsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLibertacaoFsList$Response(params?: {
    criteria?: LibertacaoCaucaoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<LibertacaoCaucaoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LibertacaoCaucaoFontesSeladasService.GetLibertacaoFsListPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LibertacaoCaucaoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar libertação de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLibertacaoFsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLibertacaoFsList(params?: {
    criteria?: LibertacaoCaucaoFontesSeladasCriteriaDto;
  }): Observable<LibertacaoCaucaoFontesSeladasPageDto> {

    return this.getLibertacaoFsList$Response(params).pipe(
      map((r: StrictHttpResponse<LibertacaoCaucaoFontesSeladasPageDto>) => r.body as LibertacaoCaucaoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation submeterLibertacaoFs
   */
  static readonly SubmeterLibertacaoFsPath = '/libertacao-caucao-fontes-seladas';

  /**
   * Submeter Pedido de Libertação Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterLibertacaoFs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterLibertacaoFs$Response(params?: {

    /**
     * apiRequest
     */
    body?: LibertacaoCaucaoFontesSeladasFormCreateDto
  }): Observable<StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, LibertacaoCaucaoFontesSeladasService.SubmeterLibertacaoFsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Submeter Pedido de Libertação Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterLibertacaoFs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterLibertacaoFs(params?: {

    /**
     * apiRequest
     */
    body?: LibertacaoCaucaoFontesSeladasFormCreateDto
  }): Observable<LibertacaoCaucaoFontesSeladasDto> {

    return this.submeterLibertacaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>) => r.body as LibertacaoCaucaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation getLibertacaoCaucao
   */
  static readonly GetLibertacaoCaucaoPath = '/libertacao-caucao-fontes-seladas/{id}';

  /**
   * Obter libertação caução fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLibertacaoCaucao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLibertacaoCaucao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, LibertacaoCaucaoFontesSeladasService.GetLibertacaoCaucaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Obter libertação caução fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLibertacaoCaucao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLibertacaoCaucao(params: {
    id: number;
  }): Observable<LibertacaoCaucaoFontesSeladasDto> {

    return this.getLibertacaoCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>) => r.body as LibertacaoCaucaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateLibertacaoCaucao
   */
  static readonly UpdateLibertacaoCaucaoPath = '/libertacao-caucao-fontes-seladas/{id}';

  /**
   * Atualizar libertação caução fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLibertacaoCaucao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLibertacaoCaucao$Response(params: {
    id: number;
    body?: LibertacaoCaucaoFontesSeladasFormUpdateDto
  }): Observable<StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, LibertacaoCaucaoFontesSeladasService.UpdateLibertacaoCaucaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Atualizar libertação caução fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateLibertacaoCaucao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLibertacaoCaucao(params: {
    id: number;
    body?: LibertacaoCaucaoFontesSeladasFormUpdateDto
  }): Observable<LibertacaoCaucaoFontesSeladasDto> {

    return this.updateLibertacaoCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<LibertacaoCaucaoFontesSeladasDto>) => r.body as LibertacaoCaucaoFontesSeladasDto)
    );
  }

}
